import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const FeedbackService = {
  getMailConfig: () => RequestUtil.get({ url: REQUEST_URL.CUSTOMER_FEEDBACK_MAIL }),

  updateMailConfig: (data: { to: string[]; cc: string[] }) =>
    RequestUtil.put({ url: REQUEST_URL.CUSTOMER_FEEDBACK_MAIL, data }),

  listLogs: (params?: { page?: number; limit?: number; topic?: string }) =>
    RequestUtil.get({
      url: REQUEST_URL.CUSTOMER_FEEDBACK_LOGS,
      query: params || {},
    }),
};
